'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContainerStyled = undefined;

var _templateObject = _taggedTemplateLiteral(['\n      padding:\n        ', ' ', ';\n    '], ['\n      padding:\n        ', ' ', ';\n    ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var propTypes = {
  /** Container will have maximum width and will br centered on screen */
  boxed: _propTypes2.default.bool,

  /** Container will occupy all available space */
  spread: _propTypes2.default.bool
  /**
  * Define component theme config
  * See https://github.com/styled-components/styled-components/blob/master/docs/theming.md
  * for more information
  */
  ,
  theme: _propTypes2.default.object
};
var defaultProps = {
  boxed: false,
  spread: false
};
/** PROP RECEIVERS */

var padding = function padding(_ref) {
  var themeFromProvider = _ref.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var obj = theme.reactackle.components.grid.container.breakpoints;
  var breakpoints = obj.map(function (item) {
    return (0, _styledComponents.css)(['', ''], (0, _reactackleCore.media)(item.breakpoint)(_templateObject, (0, _reactackleCore.getValueString)(item.paddingY), (0, _reactackleCore.getValueString)(item.paddingX)));
  });
  var _theme$reactackle$com = theme.reactackle.components.grid.container,
      paddingY = _theme$reactackle$com.paddingY,
      paddingX = _theme$reactackle$com.paddingX;
  return (0, _styledComponents.css)(['padding:', ' ', ';', ''], (0, _reactackleCore.getValueString)(paddingY), (0, _reactackleCore.getValueString)(paddingX), breakpoints);
};

var spread = function spread(_ref2) {
  var spread = _ref2.spread;
  return spread && 'flex-grow: 1;';
};

var boxed = function boxed(_ref3) {
  var boxed = _ref3.boxed,
      themeFromProvider = _ref3.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  return boxed ? 'max-width:\n        ' + (0, _reactackleCore.getValueString)(theme.reactackle.components.grid.row.maxWidth) + ';' : 'max-width: 100%;';
};

var base = function base(_ref4) {
  var themeFromProvider = _ref4.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var fontFamily = theme.reactackle.fontFamily[theme.reactackle.body.fontFamily];
  return '\n    font-family: ' + fontFamily + ';\n    box-sizing: border-box;\n  ';
};
/** STYLES */


var ContainerStyled = exports.ContainerStyled = _styledComponents2.default.div.withConfig({
  displayName: 'ContainerStyled'
})(['width:100%;margin:0 auto;', ';', ' ', ' ', ' ', ';'], (0, _reactackleCore.transition)('padding'), base, padding, boxed, spread);

ContainerStyled.propTypes = propTypes;
ContainerStyled.defaultProps = defaultProps;
ContainerStyled.displayName = 'ContainerStyled';